import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.62 2.55c-.92-.92-2.125-1.379-3.33-1.379A4.692 4.692 0 0 0 9 3.946 4.693 4.693 0 0 0 4.71 1.17a4.71 4.71 0 0 0-3.33 8.04L9 16.83l7.62-7.62a4.708 4.708 0 0 0 0-6.66zm-.848 5.811L9 15.133 2.228 8.361A3.486 3.486 0 0 1 1.2 5.88c0-.938.365-1.819 1.028-2.482.663-.663 1.544-1.028 2.482-1.028a3.486 3.486 0 0 1 3.196 2.068l.468 1.038h1.253l.468-1.038a3.486 3.486 0 0 1 3.196-2.069c.938 0 1.819.365 2.482 1.028A3.493 3.493 0 0 1 16.8 5.88c0 .937-.365 1.818-1.028 2.481zM8.65 9.536L7.087 7.974l-.848.848 2.411 2.412 4.78-4.78-.849-.848-3.931 3.93z" />
  </svg>
);

export default SvgComponent;
